module.exports = "<h2 class=\"text-title\">Mídias Sociais</h2>\n<div class=\"row text-center\">\n  <div class=\"col-sm-6 col-md-4 col-lg-4\" *ngFor=\"let item of items | async\">\n    <a href=\"{{item.link}}\" target=\"_blank\">\n      <img class=\"rounded-circle\" src=\"{{item.icon}}\" width=\"100\" height=\"100\">\n      <h2>{{item.nome}}</h2>\n    </a>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home-social/home-social.component.html
// module id = ./src/app/home/home-social/home-social.component.html
// module chunks = main